import { Box } from "@mui/material";
import React from "react";

const hideHorizontalScrollbarSx = {
    overflowX: "auto",
    WebkitOverflowScrolling: "touch",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    "&::-webkit-scrollbar": { display: "none" },
};

/** Horizontal chip row with left/right arrows when content overflows. */
export default function TagScrollRow({ children, sx }) {
    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                pb: 1.5,
                mb: 1,
                ...sx,
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    gap: 0.75,
                    width: "100%",
                    px: 0.5,
                    ...hideHorizontalScrollbarSx,
                }}
            >
                {children}
            </Box>
        </Box>
    );
}
